import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/finance/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
